<template class="py-0">
  <fwb-sidebar class="bg-black text-white pt-1 py-0">
    <div
      :class="[
        'bg-black text-white p-0 m-0 h-screen fixed ml-[-12px] mt-[-20px] mr-[-12px] px-0 transition-all duration-300',
        isCollapsed ? 'w-[60px]' : 'w-[15%]'
      ]"
    >
      <!-- Sidebar Header -->
      <div class="flex items-center justify-between p-5" :class="{ 'justify-center': isCollapsed }">
        <div class="flex items-center" :class="{ 'w-full justify-center': isCollapsed }">
          <a href="/home" class="flex items-center bg-black text-white mb-0" :class="{ 'justify-center': isCollapsed }">
            <template v-if="!isCollapsed">
              <img src="@/assets/imgs/LogoTuin.svg" class="h-6 mr-3 sm:h-7" alt="">
              <span class="self-center text-xl font-semibold whitespace-nowrap dark:text-white"></span>
            </template>
            <template v-else>
              <svg width="24" height="37" viewBox="0 0 24 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M12.016 3.817 23.96 9.518l.038-3.616L12.812.187c-.564-.288-1.167-.23-1.625.08a2 2 0 0 0-.144.065L.024 5.88 0 9.551l11.74-5.575q.144-.068.276-.159m-.378 8.714c-4.914 0-8.477 3.631-8.477 9.376v14.342H0V21.907C0 15.25 5.043 9.55 11.638 9.55S24 15.25 24 21.907v14.342h-3.161V21.907c-.46-5.839-4.287-9.376-9.201-9.376" fill="#fff"/>
                <path d="M15.158 27.29a2.489 2.489 0 1 0 0-4.977 2.489 2.489 0 0 0 0 4.977" fill="#FF4265"/>
              </svg>
            </template>
          </a>
        </div>
        <!-- Collapse Button-->
        <button
          v-if="!isCollapsed"
          @click="$emit('toggle-collapse')"
          class="absolute right-2 rounded-lg transition-colors duration-200"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 20.25H16.25C17.3109 20.25 18.3283 19.8286 19.0784 19.0784C19.8286 18.3283 20.25 17.3109 20.25 16.25V13.75M12 20.25H7.75C6.68913 20.25 5.67172 19.8286 4.92157 19.0784C4.17143 18.3283 3.75 17.3109 3.75 16.25V12M12 20.25V15C12 14.2044 11.6839 13.4413 11.1213 12.8787C10.5587 12.3161 9.79565 12 9 12H3.75M3.75 12V7.75C3.75 6.68913 4.17143 5.67172 4.92157 4.92157C5.67172 4.17143 6.68913 3.75 7.75 3.75H10.25M20.25 10.25H14.75C14.4848 10.2499 14.2305 10.1445 14.043 9.957M14.043 9.957C13.862 9.776 13.75 9.526 13.75 9.25V3.75M14.043 9.957L14.75 9.25L20.25 3.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      <div v-if="isCollapsed">
        <fwb-tooltip 
        placement="right" 
        theme="bg-darkgray"
      >
        <template #trigger>
          <div
            @click="$emit('toggle-collapse')"
            class="flex items-center justify-center m-2 p-2 text-base font-normal text-white transition duration-75 rounded-lg group hover:bg-darkgray cursor-pointer"        
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20" fill="none">
              <path d="M13.0103 1.97852H18.0103M18.0103 1.97852V6.97852M18.0103 1.97852L13.0103 6.97852M1.98926 6.97852V1.97852H7.01026M7.01026 18.0205H1.98926V12.9785M18.0103 12.9785V18.0205H13.0103M13.0103 12.9785L18.0103 17.9785M2.01026 1.97852L7.01026 6.97852M7.01026 12.9785L2.01026 17.9785" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>          
          </div>
        </template>
        <template #content>
          Abrir menú
        </template>
        </fwb-tooltip>
        <!-- Home -->
        <fwb-tooltip 
          v-if="step_user && step_user.step >=3 "
          placement="right" 
          theme="bg-darkgray"
        >
          <template #trigger>
            <fwb-sidebar-item
              to="/home"
              class="m-2 p-2 text-base font-normal text-white transition duration-75 rounded-lg group hover:!bg-darkgray2"        
              :class="{ 'bg-darkgray': current_path == 'home' }"
              @click="change_path('home')"
            >
              <template #icon>
                <img
                  src="@/assets/imgs/icons/home_page.svg"
                  alt="tuin home page"
                  width="24"
                  height="24"
                >          
              </template>
            </fwb-sidebar-item>
          </template>
          <template #content>
            Home
          </template>
        </fwb-tooltip>
        <!-- Bolsa inmobiliaria -->
        <fwb-tooltip 
          v-if="step_user && step_user.step >=3 "
          placement="right" 
          theme="bg-darkgray"
        >
          <template #trigger>
            <fwb-sidebar-item
              to="/bolsa-inmobiliaria"
              class="m-2 p-2 text-base font-normal text-white transition duration-75 rounded-lg group hover:!bg-darkgray2"        
              :class="{ 'bg-darkgray': current_path == 'bolsa-inmobiliaria' }"
              @click="change_path('bolsa-inmobiliaria')"
            >
              <template #icon>
                <img
                  src="@/assets/imgs/icons/bolsa_inmobiliaria.svg"
                  alt="tuin bolsa inmobiliaria"
                  width="24"
                  height="24"
                >          
              </template>
            </fwb-sidebar-item>
          </template>
          <template #content>
            Bolsa inmobiliaria
          </template>
        </fwb-tooltip>
        <!-- Dashboard -->
 
        <!-- Propiedades -->
        <fwb-tooltip 
          v-if="step_user && step_user.step >= 3 "
          placement="right" 
          theme="bg-darkgray"
        >
          <template #trigger>
            <fwb-sidebar-item
              to="/properties"
              class="m-2 p-2 text-base font-normal text-white transition duration-75 rounded-lg group hover:!bg-darkgray2"
              :class="{ 'bg-darkgray': current_path == 'properties' }"
              @click="change_path('properties')"
            >
              <template #icon>
                <img
                  src="@/assets/imgs/icons/mis_propiedades.svg"
                  alt="mis propiedades"
                  width="24"
                  height="24"
                >          
              </template>
            </fwb-sidebar-item>
          </template>
          <template #content>
            Mis propiedades
          </template>
        </fwb-tooltip>
        <!-- Propiedades -->

        <!-- Prospectos -->
        <fwb-tooltip 
          v-if="step_user && step_user.step >= 3 "
          placement="right" 
          theme="bg-darkgray"
        >
          <template #trigger>
            <fwb-sidebar-item 
              to="/customers"
              class="m-2 p-2 text-base font-normal text-white transition duration-75 rounded-lg group hover:!bg-darkgray2"
              :class="{ 'bg-darkgray': current_path == 'customers' }"
              @click="change_path('customers')"
            >
              <template #icon>
                <img
                  src="@/assets/imgs/icons/prospectos.svg"
                  alt="mis propiedades"
                  width="24"
                  height="24"
                >          
              </template>
            </fwb-sidebar-item>
          </template>
          <template #content>
            Prospectos
          </template>
        </fwb-tooltip>
        
        <!-- Prospectos -->

        <!-- Mi inmobiliaria -->
        <fwb-tooltip 
          v-if="step_user && step_user.step >= 3 "
          placement="right" 
          theme="bg-darkgray"
        >
          <template #trigger>
            <fwb-sidebar-item 
              to="/info-company"
              class="m-2 p-2 text-base font-normal text-white transition duration-75 rounded-lg group hover:!bg-darkgray2"
              :class="{ 'bg-darkgray': current_path == 'info-company' }"
              @click="change_path('info-company')"
            >
              <template #icon>
                <img
                  src="@/assets/imgs/icons/mi_inmobiliaria.svg"
                  alt="mis propiedades"
                  width="24"
                  height="24"
                >          
              </template>
            </fwb-sidebar-item>
          </template>
          <template #content>
            Mi inmobiliaria
          </template>
        </fwb-tooltip>
        <!-- Mi inmobiliaria -->

        <!-- Mi perfil -->
        <fwb-tooltip 
          v-if="step_user && step_user.step >= 3 "
          placement="right" 
          theme="bg-darkgray"
        >
          <template #trigger>
            <fwb-sidebar-item 
              to="/info-profile"
              class="m-2 p-2 text-base font-normal text-white transition duration-75 rounded-lg group hover:!bg-darkgray2"
              :class="{ 'bg-darkgray': current_path == 'info-profile' }"
              @click="change_path('info-profile')"   
            >
              <template #icon>
                <img
                  src="@/assets/imgs/icons/mi_perfil.svg"
                  alt="mis propiedades"
                  width="24"
                  height="24"
                >          
              </template>
            </fwb-sidebar-item>
          </template>
          <template #content>
            Mi perfil
          </template>
        </fwb-tooltip>
        <!-- Salir  -->
        <fwb-tooltip 
          placement="right" 
          theme="bg-darkgray"
        >
          <template #trigger>
            <fwb-sidebar-item 
              class="m-2 p-2 text-base font-normal text-white transition duration-75 rounded-lg group hover:!bg-darkgray2"
              @click="outsession"
            >
              <template #icon>
                <img
                  src="@/assets/imgs/icons/logout.svg"
                  alt="logout"
                  width="24"
                  height="24"
                >
              </template>
            </fwb-sidebar-item>
          </template>
          <template #content>
            Salir
          </template>
        </fwb-tooltip>
        <!-- Salir  -->
      </div>

      <div v-if="!isCollapsed">
        <!-- Home -->
        <fwb-sidebar-item
              v-if="step_user && step_user.step >=3 "
              to="/home"
              class="m-2 p-2 text-base font-normal text-white transition duration-75 rounded-lg group hover:!bg-darkgray2"        
              :class="{ 'bg-darkgray': current_path == 'home' }"
              @click="change_path('home')"
        >
              <template #icon>
                <img
                  src="@/assets/imgs/icons/home_page.svg"
                  alt="tuin home page"
                  width="24"
                  height="24"
                >          
              </template>
              <template #default>
                <span class="text-white">Home</span>
              </template>
        </fwb-sidebar-item>
        <!-- Bolsa inmobiliaria -->
        <fwb-sidebar-item
              v-if="step_user && step_user.step >=3 "
              to="/bolsa-inmobiliaria"
              class="m-2 p-2 text-base font-normal text-white transition duration-75 rounded-lg group hover:!bg-darkgray2"        
              :class="{ 'bg-darkgray': current_path == 'bolsa-inmobiliaria' }"
              @click="change_path('bolsa-inmobiliaria')"
        >
              <template #icon>
                <img
                  src="@/assets/imgs/icons/bolsa_inmobiliaria.svg"
                  alt="tuin bolsa inmobiliaria"
                  width="24"
                  height="24"
                >          
              </template>
              <template #default>
                <span class="text-white">Bolsa inmobiliaria</span>
              </template>
        </fwb-sidebar-item>
        <!-- Dashboard -->

        
        <!-- Propiedades -->
        <fwb-sidebar-item
                v-if="step_user && step_user.step >= 3 "
                to="/properties"
                class="m-2 p-2 text-base font-normal text-white transition duration-75 rounded-lg group hover:!bg-darkgray2"
                :class="{ 'bg-darkgray': current_path == 'properties' }"
                @click="change_path('properties')"
        >
                <template #icon>
                  <img
                    src="@/assets/imgs/icons/mis_propiedades.svg"
                    alt="mis propiedades"
                    width="24"
                    height="24"
                  >          
                </template>
                <template #default>
                  <span class="text-white">Mis propiedades</span>
                </template>
        </fwb-sidebar-item>
        <!-- Propiedades -->

        <!-- Prospectos -->
        <fwb-sidebar-item 
              v-if="step_user && step_user.step >= 3 "
              to="/customers"
              class="m-2 p-2 text-base font-normal text-white transition duration-75 rounded-lg group hover:!bg-darkgray2"
              :class="{ 'bg-darkgray': current_path == 'customers' }"
              @click="change_path('customers')"
        >
              <template #icon>
                <img
                  src="@/assets/imgs/icons/prospectos.svg"
                  alt="mis propiedades"
                  width="24"
                  height="24"
                >          
              </template>
              <template #default>
                <span class="text-white">
                  Prospectos
                </span>
              </template>
        </fwb-sidebar-item>
        
        <!-- Prospectos -->

        <!-- Mi inmobiliaria -->
        <fwb-sidebar-item 
              v-if="step_user && step_user.step >= 3 "
              to="/info-company"
              class="m-2 p-2 text-base font-normal text-white transition duration-75 rounded-lg group hover:!bg-darkgray2"
              :class="{ 'bg-darkgray': current_path == 'info-company' }"
              @click="change_path('info-company')"
        >
              <template #icon>
                <img
                  src="@/assets/imgs/icons/mi_inmobiliaria.svg"
                  alt="mis propiedades"
                  width="24"
                  height="24"
                >          
              </template>
              <template #default>
                <span class="text-white">
                  Mi inmobiliaria
                </span>
              </template>
        </fwb-sidebar-item>
        <!-- Mi inmobiliaria -->

        <!-- Mi perfil -->
        <fwb-sidebar-item 
              v-if="step_user && step_user.step >= 3 "
              to="/info-profile"
              class="m-2 p-2 text-base font-normal text-white transition duration-75 rounded-lg group hover:!bg-darkgray2"
              :class="{ 'bg-darkgray': current_path == 'info-profile' }"
              @click="change_path('info-profile')"   
        >
              <template #icon>
                <img
                  src="@/assets/imgs/icons/mi_perfil.svg"
                  alt="mis propiedades"
                  width="24"
                  height="24"
                >          
              </template>
              <template #default>
                <span class="text-white">
                  Mi perfil
                </span>
              </template>
        </fwb-sidebar-item>
        <!-- Salir  -->
        <fwb-sidebar-item 
              class="m-2 p-2 text-base font-normal text-white transition duration-75 rounded-lg group hover:!bg-darkgray2"
              @click="outsession"
        >
              <template #icon>
                <img
                  src="@/assets/imgs/icons/logout.svg"
                  alt="logout"
                  width="24"
                  height="24"
                >
              </template>
              <template #default>
                Salir
              </template>
        </fwb-sidebar-item>
        <!-- Salir  -->
      </div>
    </div>
  </fwb-sidebar>
</template>
<script setup>
import {
  FwbSidebar,
  FwbSidebarItem,
  FwbTooltip,
} from "flowbite-vue";

import { ref, onMounted, computed } from "vue";
import { useStore } from 'vuex';

// Store
const store = useStore();

// Props
defineProps({
  isCollapsed: {
    type: Boolean,
    required: false,
    default: false
  }
});

// Emits
defineEmits(['toggle-collapse']);

// Reactive data
const current_path = ref("configuration");
const dropdownRef = ref(null);

// Computed
const step_user = computed(() => store.getters.getUserSession);

// Methods
async function outsession() {
  await store.dispatch("clearUserSession");
  window.location.replace("/login");
}

function change_path(path_link) {
  current_path.value = path_link;
}

const openDropdown = () => {
  const dropdownTrigger = dropdownRef.value?.$el?.querySelector('[aria-controls="dropdown-content"]');
  if (dropdownTrigger) {
    dropdownTrigger.click();
  }
};

const setActivePath = () => {
  openDropdown();
};

// Lifecycle
onMounted(() => {  
  setActivePath();    
});
</script>

<style scoped>
aside > div:first-child {
  background-color: black !important;
  color: white;
}

.open {
  /* Aquí puedes agregar clases adicionales que controlen la visibilidad */
  display: block;
}

/* Asegura que los tooltips sean siempre visibles */
:deep(.fwb-tooltip) {
  z-index: 9999;
}

:deep(.fwb-tooltip__content) {
  opacity: 1 !important;
  visibility: visible !important;
}

/* Mejora la transición de los tooltips */
:deep(.fwb-tooltip__trigger) {
  transition: all 0.2s ease;
}

/* Asegura que los tooltips se muestren correctamente en el sidebar colapsado */
:deep(.fwb-tooltip[data-popper-placement="right"]) {
  margin-left: 8px;
}
</style>